module.exports = __webpack_public_path__ + "img/worksbot_img20022507.4052801c.jpg";